import React, { useState } from 'react';
import { FiInfo, FiImage, FiMail, FiGrid, FiX } from 'react-icons/fi';
import { FaSpotify, FaApple, FaYoutube, FaInstagram } from 'react-icons/fa';

const NavBar = () => {
  const [open, setOpen] = useState(false);
  const navItems = [
    { href: 'https://tr.ee/tvwDfBXSIO', label: 'Music', icon: <FaSpotify />, external: true },
    { href: '#about', label: 'About', icon: <FiInfo /> },
    { href: '#gallery', label: 'Gallery', icon: <FiImage /> },
    { href: '#contact', label: 'Contact', icon: <FiMail /> },
  ];

  return (
    <header className="navbar">
      <a href="#top" className="brand" aria-label="Go to top">
        <span className="brand-name">DAVID JHAY</span>
      </a>
      <button
        className="mobile-toggle"
        aria-label="Toggle navigation"
        aria-expanded={open}
        aria-controls="primary-navigation"
        onClick={() => setOpen(!open)}
      >
        {open ? <FiX /> : <FiGrid />}
      </button>
      <nav id="primary-navigation" className={`nav-links ${open ? 'open' : ''}`} aria-label="Primary">
        {navItems.map((item) => (
          <a
            key={item.href}
            className="nav-link"
            href={item.href}
            {...(item.external ? { target: '_blank', rel: 'noreferrer' } : {})}
          >
            <span className="nav-icon" aria-hidden="true">{item.icon}</span>
            <span className="nav-text">{item.label}</span>
          </a>
        ))}
      </nav>
      <div className="nav-social" aria-label="Social links">
        <a className="icon-btn" href="https://tr.ee/tvwDfBXSIO" target="_blank" rel="noreferrer" aria-label="Spotify">
          <FaSpotify />
        </a>
        <a className="icon-btn" href="https://music.apple.com" target="_blank" rel="noreferrer" aria-label="Apple Music">
          <FaApple />
        </a>
        <a className="icon-btn" href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube">
          <FaYoutube />
        </a>
        <a className="icon-btn" href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
          <FaInstagram />
        </a>
      </div>
    </header>
  );
};

export default NavBar;
